import { API, Auth } from "aws-amplify";
import {Checkbox, Button, Menu, MenuItem} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import ButtonMaterialUIProgress from "../../CommonUtilities/ButtonMaterialUIProgress";
import Typography from "@material-ui/core/Typography";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';


export default function StudentDocumentsTable({studentUuid}) {
    const [documents, setDocuments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);

    function loadStudentDocumentsApi() {
        return API.get("misServiciosEscolares", `/documents/${studentUuid}`);
    }

    const setStudentDocumentsApi = () => {
        return API.put("misServiciosEscolares", `/documents/${studentUuid}`, {
            body: documents
        });
    };

    const getKardexUrl = async (split, hideAverage = false) => {
        const currentUser = await Auth.currentAuthenticatedUser();
        const userSub = currentUser?.attributes?.sub;

        let path = `/pdf/kardex/${studentUuid}?split=${split}&userId=${userSub}`;
        if (hideAverage) {
            path += '&hideAverage=true';
        }
        return API.get("misServiciosEscolares", path);
    };

    async function onLoad() {
        try {
            const documentsMetadata = await loadStudentDocumentsApi();
            setDocuments(documentsMetadata.documents);
        } catch (e) {
            console.log("Error loading student notes", e.message);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        onLoad();
    }, [studentUuid]);

    const handleCheckboxChange = (event, index) => {
        setDocuments([
            ...documents.slice(0, index),
            {
                ...documents[index],
                delivered: event.target.checked,
            },
            ...documents.slice(index + 1)
        ]);
    };

    const updateDocuments = async () => {
        try {
            setLoading(true);
            await setStudentDocumentsApi();
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    const getKardexSinPromedio = async () => {
        try {
            setLoading(true);
            /**
             * Getting Split from user input. Default is 26
             */
            const split = window.prompt("Please enter a number", "26");
            if (split === null) {
                // User clicked "Cancel", stop execution
                return;
            }
            if (isNaN(Number(split))) {
                // User didn't enter a valid number, stop execution
                console.log("Invalid number entered");
                return;
            }

            /**
             * Getting Kardex URL without average
             */
            const {data: url} = await getKardexUrl(split, true);
            window.open(url, '_blank');
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };

    const handleKardexMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleKardexMenuClose = () => {
        setAnchorEl(null);
    };

    const getKardexWithDigits = async (digits) => {
        try {
            setLoading(true);
            handleKardexMenuClose();

            /**
             * Getting Split from user input. Default is 26
             */
            const split = window.prompt("Please enter a number", "26");
            if (split === null) {
                // User clicked "Cancel", stop execution
                setLoading(false);
                return;
            }
            if (isNaN(Number(split))) {
                // User didn't enter a valid number, stop execution
                console.log("Invalid number entered");
                setLoading(false);
                return;
            }

            const {data: url} = await API.get(
                "misServiciosEscolares",
                `/pdf/kardex/${studentUuid}?split=${split}&digits=${digits}`
            );
            window.open(url, '_blank');
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };

    const getConstancia70 = async () => {
        try {
            setLoading(true);
            const {data: url} = await API.get(
                "misServiciosEscolares",
                `/constancia70-pdf/${studentUuid}`
            );
            window.open(url, '_blank');
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div>
                <Typography variant="h5" component="h2">
                    Imprimir Documentos
                </Typography>
                <Button
                    color='secondary'
                    variant='contained'
                    onClick={handleKardexMenuClick}
                    disabled={loading}
                    endIcon={<ArrowDropDownIcon />}
                >
                    Crear Kardex
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleKardexMenuClose}
                >
                    <MenuItem onClick={() => getKardexWithDigits(1)}>
                        1 decimal place
                    </MenuItem>
                    <MenuItem onClick={() => getKardexWithDigits(2)}>
                        2 decimal places
                    </MenuItem>
                </Menu>
                <ButtonMaterialUIProgress
                    text="Kardex sin promedio"
                    color='secondary'
                    variant='contained'
                    onClick={getKardexSinPromedio}
                    loading={loading}
                    style={{marginLeft: '10px'}}
                />
                <ButtonMaterialUIProgress
                    text="Constancia 70% Servicio Social"
                    color='primary'
                    variant='contained'
                    onClick={getConstancia70}
                    loading={loading}
                    style={{marginLeft: '10px'}}
                />
                {/*<div>*/}
                {/*    <Link target="_blank" href={`https://prod.api.misserviciosescolares.com/pdf/kardex/${studentUuid}?split=32`}>Kardex</Link>*/}
                {/*</div>*/}
            </div>
            <div style={{marginTop: '25px'}}>
                <Typography variant="h5" component="h2">
                    Registrar Documentos entregados
                </Typography>
                <ButtonMaterialUIProgress
                    text="Guardar Información"
                    color='secondary'
                    variant='contained'
                    onClick={updateDocuments} loading={loading}
                />
                {documents.length > 0 && documents.map((document, index) => {
                    return <div>
                        <>
                            <Checkbox
                                checked={document.delivered}
                                onChange={e => handleCheckboxChange(e, index)}
                                inputProps={{'aria-label': 'primary checkbox'}}
                            />
                        </>
                        <>{document.name}</>
                    </div>;
                })}
            </div>
        </div>
    );
};
